export const getSpecTitle = (spec: {
  id?: string | null;
  name?: string | null;
  displayName?: string | null;
}): string => spec.displayName || spec.name || spec.id || "";
